/**
 * 이벤트 위임 담당 클래스: TvingEventDelegator
 * 시스템 최상단에서 이벤트 핸들러를 관리합니다.
 * 모든 이벤트 핸들러는 이벤트 위임 담당 클래스에 등록되어야 합니다.
 *
 */
var TvingEventDelegator = /** @class */ (function () {
    function TvingEventDelegator(eventTypes) {
        if (eventTypes === void 0) { eventTypes = TvingEventDelegator.DEFAULT_EVENT_TYPES; }
        var _this = this;
        // 일반 이벤트 큐
        this.eventQueue = {};
        // 우선순위 이벤트 큐, 우선순위 이벤트는 일반 이벤트보다 먼저 실행됩니다.
        this.priorityEventQueue = {};
        this.eventTypes = eventTypes;
        this.eventTypes.forEach(function (eventType) {
            _this.eventQueue[eventType] = [];
            _this.priorityEventQueue[eventType] = [];
        });
        this.eventHandlers = eventTypes.map(function (eventType) { return function (event) {
            var _a, _b;
            // 사용하고자 하는 이벤트가 전파되는걸 차단합니다.
            // 우선순위 이벤트를 먼저 실행합니다.
            var isPropagation = true;
            for (var i = 0; i < _this.priorityEventQueue[eventType].length; i += 1) {
                var handler = _this.priorityEventQueue[eventType][i];
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                isPropagation = (_a = handler(event)) !== null && _a !== void 0 ? _a : false;
                if (!isPropagation) {
                    break;
                }
            }
            // 우선순위 이벤트 실행 이후 전파하고자 한다면, 일반 이벤트를 실행합니다.
            if (isPropagation) {
                for (var i = 0; i < _this.eventQueue[eventType].length; i += 1) {
                    var handler = _this.eventQueue[eventType][i];
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    isPropagation = (_b = handler(event)) !== null && _b !== void 0 ? _b : false;
                    // if (eventType === 'keydown') {
                    //   console.groupCollapsed('Event Callstack', isPropagation, this.eventQueue[eventType].length, eventType, handler.name);
                    //   console.trace(); // hidden in collapsed group
                    //   console.groupEnd();
                    // }
                    if (!isPropagation) {
                        break;
                    }
                }
            }
            if (!isPropagation) {
                event.stopPropagation();
                event.preventDefault();
            }
        }; });
        this.registerAll();
    }
    // 모든 이벤트를 등록합니다.
    TvingEventDelegator.prototype.registerAll = function () {
        var _this = this;
        this.eventTypes.forEach(function (eventType, index) {
            document.addEventListener(eventType, _this.eventHandlers[index]);
        });
    };
    // 모든 이벤트를 해제합니다.
    TvingEventDelegator.prototype.removeAll = function () {
        var _this = this;
        this.eventTypes.forEach(function (eventType, index) {
            document.removeEventListener(eventType, _this.eventHandlers[index]);
        });
    };
    // 이벤트를 등록합니다.
    TvingEventDelegator.prototype.addEventListener = function (eventType, handler) {
        if (!this.eventTypes.includes(eventType)) {
            throw new Error("Invalid event type: ".concat(eventType));
        }
        this.eventQueue[eventType].unshift(handler);
    };
    // 이벤트를 해제합니다.
    TvingEventDelegator.prototype.removeEventListener = function (eventType, handler) {
        if (!this.eventTypes.includes(eventType)) {
            throw new Error("Invalid event type: ".concat(eventType));
        }
        var index = this.eventQueue[eventType].indexOf(handler);
        if (index !== -1) {
            this.eventQueue[eventType].splice(index, 1);
        }
    };
    // 우선순위 이벤트를 등록합니다.
    TvingEventDelegator.prototype.addPriorityEventListener = function (eventType, handler) {
        if (!this.eventTypes.includes(eventType)) {
            throw new Error("Invalid event type: ".concat(eventType));
        }
        this.priorityEventQueue[eventType].unshift(handler);
    };
    // 우선순위 이벤트를 해제합니다.
    TvingEventDelegator.prototype.removePriorityEventListener = function (eventType, handler) {
        if (!this.eventTypes.includes(eventType)) {
            throw new Error("Invalid event type: ".concat(eventType));
        }
        var index = this.priorityEventQueue[eventType].indexOf(handler);
        if (index !== -1) {
            this.priorityEventQueue[eventType].splice(index, 1);
        }
    };
    TvingEventDelegator.DEFAULT_EVENT_TYPES = ['keydown', 'keyup'];
    return TvingEventDelegator;
}());
export default TvingEventDelegator;
